export default (value, rule) => rule.data.test(value.toString());



// WEBPACK FOOTER //
// ./src/utils/validate/methods/regexp.js